module.exports = {
    header: {
        dates: {
            date: 'SEPTEMBER 2018',
            place: 'MOSCOW VNUKOVO-3',
        },
        slogan: `
        Do not miss<br/>
        a brand new<br/>
        business aviation<br/>
        event <span>rubae</span>
        `,
        button: 'Become an exhibitor',
        registrationButton: 'Buy a ticket',
    },
    about: {
        visitors: 'More than 8000 visitors',
        aircrafts: 'More than 30 aircrafts and helicopters',
        conference: 'New conference programm',
        about: 'More about exhibition',
    },
    exhibitors: {
        exhibitors: {
            title: 'Exhibitors',
            buttonTitle: 'Become an exhibitor',
            text: 'The RUBAE2018 exhibit application is now available.',
            links: {
                'exhibitor-manual': 'Exhibitor Manual',
                'pages/general-contractor': 'General contractor',
                'pages/freight-forwarder': 'Official freight forwarder',
                'pages/catering-partner': 'Official catering partner',
                'pages/visa-support': 'Visa support',
            },
            personalAccountButton: 'Personal account',
        },
        attendee: {
            title: 'Attendee',
            buttonTitle: 'Buy a ticket',
            text:
                'Center of business aviation Vnukovo-3 invites to visit the only business aviation event  in Russia and CIS countries from 12 September till 14 September 2018.',
            links: {
                'pages/about': 'General information',
                'pages/location': 'Location',
                'pages/exhibitor-list': 'Exhibitor list',
                pavilion_exposition: 'Pavilion exposition',
            },
        },
    },
    sponsors: 'Sponsors',
    'info-sponsors': 'Information support',
    contacts: {
        title: 'Contact us',
        legalInfo: '',
        confidention: '',
    },
    contactForm: {
        name: 'Company name',
        contactPerson: 'Contact person',
        tel: 'Tel',
        email: 'E-mail',
        address: 'Address',
        website: 'Website',
        stand: 'Stand',
        static: 'Static',
        submit: 'Submit',
        formatLabel: 'Participation format',
        successMessage: 'Thank you! We will contact you.',
        errorMessage: 'Something went wrong. Try again later.',
    },
    exhibitApplication: {
        applicationTypeButton: 'Choose type of allocation',
        valuePlaceholder: 'Enter value',
        services: {
            shellScheme: {
                title: 'Shell Scheme (min. 6㎡)',
                description:
                    'SHELL SCHEME PACKAGE includes: exhibit space, wall panels, carpeting, 1 electrical socket, 1 desk, 2 chairs, 1 lamp, 1 fascia board, liability insurance, company profile in the official RUBAE catalogue. The building of the stand is carried out by the RUBAE Official Contractor Company',
            },
            spaceOnly: {
                title: 'Space Only (min. 18㎡)',
                description:
                    'SPACE ONLY includes: liability insurance, company profile in the official RUBAE catalogue. The building and design of the stand is carried out in accordance with the rules and requirements of the exhibitor manual.',
            },
            staticDisplayChalet3: {
                title: 'Static Display Chalet (3×3)',
                description:
                    'CHALET includes: fascia, 1 electrical socket, floor with carpeting.',
            },
            staticDisplayChalet5: {
                title: 'Static Display Chalet (5×5)',
                description:
                    'CHALET includes: fascia, 1 electrical socket, floor with carpeting.',
            },
            upperDeck: {
                title: 'Upper Deck (double storey - space only)',
            },
            wallBrandingChalet3: {
                title: 'Wall branding chalet (for chalet 3×3)',
            },
            wallBrandingChalet5: {
                title: 'Wall branding chalet (for chalet 5×5)',
            },
            catalogueAdPage05: { title: '1/2 Page, full-colour' },
            catalogueAdPage1: { title: '1/1 Page, full-colour' },
        },
        units: {
            sqrm: '㎡',
            unit: 'unit',
        },
        addButton: 'Add allocation',
        catalogueAd: 'RUBAE Catalogue AD Rates',
        total: 'Total cost',
        formTitle: 'Application form',
        contactsTitle: 'Contacts',
        contactsSubtitle: '(all fields are required)',
        allocationTitle: 'Allocation',
        comment:
            'This application is the basis for the contract and invoice, which should be paid in the amount of 50% within 10 days after the invoice date. Another 50% should be paid till 31 July 2018. The prices include VAT. Please note that 50% deposit is not refundable in case of cancellation of the company to participate in the exhibition.',
    },
    pages: {
        schedule: {
            about: 'About',
            registration: 'Registration',
            preview: 'Preview',
            schedule: 'Conference program',
            scheduleLink: 'Download conference program of the RUBAE Show',
        },
    },
};



// WEBPACK FOOTER //
// ./src/data/messages/en.js